import React from "react";

import { Box, CircularProgress, Typography } from "@mui/material";

import Room from "../Components/Room";

import { useRooms } from "../Hooks/useRooms";


export default function Home() {

    const {
        rooms,
        loading,
        error,
        addPatient,
        deletePatient
    } = useRooms();


    if (loading) {

        return (

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "50vh"
                }}
            >

                <CircularProgress />

            </Box>

        );

    }


    if (error) {

        return (

            <Box sx={{ m: 3 }}>

                <Typography
                    color="error"
                    variant="h6"
                >
                    Errore: {error}
                </Typography>

            </Box>

        );

    }


    return (

        <Box
            sx={{
                width: '50ch',
                m: 2
            }}
        >

            <Box
                sx={{
                    p: 3,
                    mb: 2,
                    border: '1px solid rgba(0,0,0,0.23)',
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',
                    textAlign: 'center'
                }}
            >

                <Box
                    component="h1"
                    sx={{
                        m: 0,
                        fontSize: '1.6rem',
                        color: '#1976d2'
                    }}
                >
                    Gestione Stanze
                </Box>


                <Box
                    component="p"
                    sx={{
                        m: 0,
                        mt: 1,
                        fontSize: '1rem',
                        color: 'text.secondary'
                    }}
                >
                    Inserimento e monitoraggio delle rilevazioni
                </Box>

            </Box>


            {rooms.map((room) => (

                <Room
                    key={room.id}
                    id={room.id}
                    patients={room.patients}
                    addPatient={addPatient}
                    deletePatient={deletePatient}
                />

            ))}

        </Box>

    );
}